import { formatters } from "@/plugins/formatters";
import "@/plugins/formatters";
import moment from "moment";

export const PERMISSOES_NEGOCIOS = {
  listar: "Negocios.index",
  adicionar: "Negocios.add",
  editar: "Negocios.edit",
  excluir: "Negocios.delete",
  reabrir: "Negocios.reabrir",
  comissao: "Negocios.comissao",
  producao: "Negocios.producao",
  etapas: "Negocios.etapas",
  linhas: "Negocios.linhas",
  config: "Negocios.config",
  reatribuirCarteira: "Negocios.reatribuirCarteira"
};

export default {
  data() {
    return {
      moneyFormat: {
        decimal: ",",
        thousands: ".",
        prefix: "R$ ",
        precision: 2,
        masked: false
      }
    };
  },
  computed: {
    acessoNegocios() {
      const user = this.$store.getters.dataUser;

      return user && Array.isArray(user.acesso) ? user.acesso : [];
    },
    telaEstreita() {
      return Boolean(this.$q && this.$q.screen && this.$q.screen.lt.md);
    },
    podeAdicionarNegocios() {
      return this.temPermissaoNegocios(PERMISSOES_NEGOCIOS.adicionar);
    },
    podeEditarNegocios() {
      return this.temPermissaoNegocios(PERMISSOES_NEGOCIOS.editar);
    },
    podeExcluirNegocios() {
      return this.temPermissaoNegocios(PERMISSOES_NEGOCIOS.excluir);
    },
    podeReabrirNegocios() {
      return this.temPermissaoNegocios(PERMISSOES_NEGOCIOS.reabrir);
    },
    podeVerComissaoNegocios() {
      return this.temPermissaoNegocios(PERMISSOES_NEGOCIOS.comissao);
    },
    podeVerProducaoNegocios() {
      return this.temPermissaoNegocios(PERMISSOES_NEGOCIOS.producao);
    },
    podeConfigurarNegocios() {
      return (
        this.temPermissaoNegocios(PERMISSOES_NEGOCIOS.etapas) ||
        this.temPermissaoNegocios(PERMISSOES_NEGOCIOS.linhas) ||
        this.temPermissaoNegocios(PERMISSOES_NEGOCIOS.config) ||
        this.temPermissaoNegocios(PERMISSOES_NEGOCIOS.reatribuirCarteira)
      );
    },
    podeReatribuirCarteiraNegocios() {
      return this.temPermissaoNegocios(PERMISSOES_NEGOCIOS.reatribuirCarteira);
    }
  },
  methods: {
    temPermissaoNegocios(chave) {
      return this.acessoNegocios.indexOf(chave) !== -1;
    },
    corDoAlertaNegocios(nivel) {
      if (nivel === "vermelho") {
        return "negative";
      }

      return nivel === "amarelo" ? "warning" : "positive";
    },
    textoDoAlertaNegocios(nivel) {
      return nivel === "amarelo" ? "black" : "white";
    },
    primeiroErro(campo) {
      const erro = this.erros[campo];

      return erro ? Object.values(erro)[0] : "";
    },
    avisar(mensagem, cor) {
      this.$q.notify({ message: mensagem, color: cor, position: "top-right" });
    },
    valorDaOportunidade(oportunidade) {
      const valor =
        oportunidade.valor_contratado === null || oportunidade.valor_contratado === undefined
          ? oportunidade.valor_solicitado
          : oportunidade.valor_contratado;

      return Number(valor || 0);
    },
    comissaoVisivel(oportunidade) {
      return Object.prototype.hasOwnProperty.call(oportunidade, "comissao_prevista");
    },
    podeEditarOportunidade(oportunidade) {
      return Boolean(
        this.podeEditarNegocios && oportunidade && oportunidade.pode_editar !== false
      );
    },
    linhasDaOportunidade(oportunidade) {
      if (Array.isArray(oportunidade.linhas) && oportunidade.linhas.length) {
        return oportunidade.linhas;
      }

      return oportunidade.linha ? [oportunidade.linha] : [];
    },
    resumoDeLinhas(oportunidade) {
      const linhas = this.linhasDaOportunidade(oportunidade);

      if (!linhas.length) {
        return { texto: "", titulo: "" };
      }

      const extras = linhas.length - 1;

      return {
        texto: linhas[0].nome + (extras > 0 ? " +" + extras : ""),
        titulo: linhas.map(linha => linha.nome).join(" · ")
      };
    },
    diasAteAlerta(dataAlerta) {
      if (!dataAlerta) {
        return null;
      }

      return moment(dataAlerta, "YYYY-MM-DD").startOf("day").diff(moment().startOf("day"), "days");
    },
    rotuloDoAlerta(dataAlerta) {
      const dias = this.diasAteAlerta(dataAlerta);

      if (dias === null || dias > 1) {
        return "";
      }

      if (dias < 0) {
        const atraso = Math.abs(dias);

        return atraso === 1 ? "Atrasada 1 dia" : "Atrasada " + atraso + " dias";
      }

      return dias === 0 ? "Vence hoje" : "Vence amanhã";
    },
    rotuloDeDiasNaEtapa(dias) {
      if (!dias) {
        return "Entrou hoje na etapa";
      }

      return dias === 1 ? "há 1 dia na etapa" : "há " + dias + " dias na etapa";
    },
    formatarMoeda(valor) {
      const numero = Number(valor || 0);

      return (numero < 0 ? "- R$ " : "R$ ") + formatters.currency(Math.abs(numero));
    },
    formatarPercentual(valor) {
      if (valor === null || valor === undefined || valor === "") {
        return "";
      }

      return Number(valor).toFixed(2).replace(".", ",") + " %";
    },
    dataParaTela(data) {
      return data ? moment(data, "YYYY-MM-DD").format("DD/MM/YYYY") : "";
    },
    dataParaApi(data) {
      return data ? moment(data, "DD/MM/YYYY").format("YYYY-MM-DD") : null;
    }
  }
};
